module.exports = __webpack_public_path__ + "static/media/slide7.7b9e3107.jpg";